<template>

    <nav :class="{'hide-me': hidden}" class="crud-nav">
        <slot></slot>
    </nav>

</template>

<style lang="scss">
    nav.crud-nav{
        background-color: #FFF;
        border-radius: $standardBorderRadius;
        padding: 1em;
        margin-bottom:3em;

        &:last-of-type{
          margin-bottom:0;
        }

        @include grid-column(12);
        @include desktop() {
            @include grid-column(4);
        }
        @include mobile(){
            display:block;
            border-radius:0;
            width:100%;
            margin:-1em 0 -1em 0;
            float:none;
            &.hide-me{
                display:none;
            }
        }

        .grouping-key-container{
            overflow-x:scroll;
            width:100%;
            display:block;
            white-space: nowrap;
            padding-bottom:1em;
            a{
                display: inline-block;
                margin: 0 5px;
                font-size: 17px;
                text-decoration: none;
                font-weight: 600;
                &:first-of-type{
                    margin-left:0;
                }
                &:last-of-type{
                    margin-right:0;
                }
            }
        }

    }
</style>

<script>
    export default {
        data() {
            return {
                hidden: false
            }
        },
        watch: {},
        computed: {
            name(){
                return this.$parent.name;
            }
        },
        methods: {},
        mounted() {
            var that = this;
            window.eventBus.$on('crud-show-nav-'+this.name, function (item) {
                that.hidden = false;
            });

            window.eventBus.$on('crud-hide-nav-'+this.name, function (item) {
                that.hidden = true;
            });
        }
    }
</script>   
